import { Grid, Icon } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React from "react";
import Draggable from "react-draggable";
import PropTypes from "prop-types";
import { getMesaColor } from "utils/colors";

const getMesaLabelStyles = (label) => {
  const normalizedLabel = `${label || ""}`.trim();
  const isSimpleNumber = /^\d{1,3}$/.test(normalizedLabel);

  if (isSimpleNumber) {
    return {
      fontSize: "2.1rem",
      lineHeight: 1,
      maxWidth: "100%",
      letterSpacing: 0,
    };
  }

  if (normalizedLabel.length <= 8) {
    return {
      fontSize: "1.15rem",
      lineHeight: 1.05,
      maxWidth: "54px",
      letterSpacing: "-0.01em",
    };
  }

  if (normalizedLabel.length <= 14) {
    return {
      fontSize: "0.92rem",
      lineHeight: 1.05,
      maxWidth: "56px",
      letterSpacing: "-0.01em",
    };
  }

  return {
    fontSize: "0.72rem",
    lineHeight: 1.05,
    maxWidth: "58px",
    letterSpacing: "-0.015em",
  };
};

const Mesa = ({
  mesa,
  moverHabilitado,
  setMesasTemporal,
  mesaTemporal,
  handleOpenPedido,
  scale,
}) => {
  const { id, numero, posicionX, posicionY, estado } = mesa;
  const { posicionX: posicionXTemporal, posicionY: posicionYTemporal } = mesaTemporal;
  const mesaLabel = `${numero || 1}`;
  const mesaLabelStyles = getMesaLabelStyles(mesaLabel);

  const updateMesaPosition = (x, y) => {
    setMesasTemporal((mesas) =>
      mesas.map((m) => {
        if (m.id === id) {
          return { ...m, posicionX: x, posicionY: y };
        }
        return m;
      })
    );
  };

  return (
    <Draggable
      style={{ position: "absolute" }}
      bounds="parent"
      scale={scale || 1}
      disabled={!moverHabilitado}
      onDrag={(_event, data) => {
        updateMesaPosition(data.x, data.y);
      }}
      onStop={(_event, data) => {
        updateMesaPosition(data.x, data.y);
      }}
      defaultPosition={{ x: posicionX || 0, y: posicionY || 0 }}
      position={{ x: posicionXTemporal || 0, y: posicionYTemporal || 0 }}
    >
      <Grid
        data-mesa-interactive="true"
        style={{
          backgroundColor: `white`,
          height: "70px",
          width: "70px",
          borderRadius: "50%",
          border: `7px solid ${getMesaColor(estado)}`,
          outline: moverHabilitado ? "5px solid gray" : `2px solid black`,
          position: "absolute",
          top: "0",
          left: "0",
          cursor: moverHabilitado ? "move" : "pointer",
        }}
        onPointerDown={(event) => {
          event.stopPropagation();
        }}
        onClick={() => !moverHabilitado && handleOpenPedido(mesa)}
      >
        <Grid
          style={{
            backgroundColor: `white`,
            position: "absolute",
            top: -20,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: "20%",
            border: `1px solid ${getMesaColor(estado)}`,
            textAlign: "center",
            minWidth: "100%",
            outline: `1px solid black`,
          }}
        >
          <SoftTypography
            variant="subtitle2"
            fontWeight="bold"
            sx={{
              userSelect: "none",
              fontSize: "0.6rem",
            }}
          >
            {estado}
          </SoftTypography>
        </Grid>
        <Grid
          width="100%"
          height="100%"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          style={{
            position: "relative",
          }}
        >
          <SoftTypography
            variant="h3"
            fontWeight="bold"
            sx={{
              userSelect: "none",
              fontSize: mesaLabelStyles.fontSize,
              lineHeight: mesaLabelStyles.lineHeight,
              maxWidth: mesaLabelStyles.maxWidth,
              textAlign: "center",
              letterSpacing: mesaLabelStyles.letterSpacing,
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            }}
          >
            {mesaLabel}
          </SoftTypography>
          <Icon fontSize="medium" color="dark">
            {moverHabilitado ? "open_with" : "table_restaurant"}
          </Icon>
        </Grid>
      </Grid>
    </Draggable>
  );
};

Mesa.propTypes = {
  mesa: PropTypes.object,
  mesaTemporal: PropTypes.object,
  guardarPosicion: PropTypes.func,
  moverHabilitado: PropTypes.bool,
  setMesasTemporal: PropTypes.func,
  handleOpenPedido: PropTypes.func,
  scale: PropTypes.number,
};

export default Mesa;
